import React from 'react';
import ReactDOM from 'react-dom/client';
// Self-hosted fonts (no external Google Fonts request). Weights must match
// what tailwind.config + the design use: Poppins 400/500/700, Playfair 400/700.
import '@fontsource/poppins/400.css';
import '@fontsource/poppins/500.css';
import '@fontsource/poppins/700.css';
import '@fontsource/playfair-display/400.css';
import '@fontsource/playfair-display/700.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, useLocation } from 'react-router-dom';
import Navbar from './components/navbars/Navbar';
import Footer from './components/footers/Footer';
import ScrollToTop from './utils/ScrollTop';
import { AuthProvider } from './context/AuthContext';
import './i18n';

// Pages built on AuthLayout are self-contained full-screen cards (auth, email
// verification, the payment result). Site chrome only crowds them, so they run
// without the navbar and footer.
const CHROMELESS_PATHS = [
  '/login',
  '/signup',
  '/forgot-password',
  '/reset-password',
  '/verify-email',
  '/payment/return',
];
// Prefixes, for routes with a parameter — /pay/<token> is a single-purpose
// payment screen sent to a student directly.
const CHROMELESS_PREFIXES = ['/pay/'];

const AppContent = () => {
  const location = useLocation();

  // Normalise a trailing slash so "/login/" is treated like "/login".
  const path = location.pathname.toLowerCase().replace(/\/+$/, '') || '/';
  const hideNavbarFooter =
    CHROMELESS_PATHS.includes(path) || CHROMELESS_PREFIXES.some((prefix) => path.startsWith(prefix));

  return (
    <>
      <ScrollToTop />
      {!hideNavbarFooter && <Navbar />}

      <App />

      {!hideNavbarFooter && <Footer />}
    </>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  </BrowserRouter>
);

reportWebVitals();